// extracted by mini-css-extract-plugin
var _1 = "NavButtonWrapper-module__disabled--udHfl";
var _2 = "NavButtonWrapper-module__root--KRSfl";
export { _1 as "disabled", _2 as "root" }
